
<template>
  <div>
    <div id="timeline-embed"></div>
    <el-dialog
     :visible.sync="dialogVisible"
      class="timeline-dialog"
      width="800px"
      :title="title"
      :append-to-body="true"
      :close-on-click-modal="true">
      <div v-if="images.length === 1">
          <img :src="images[0].url" alt="" style="width: 100%;height: auto;">
      </div>
      <el-carousel :interval="4000"  height="31.25rem" @change="changeCarousel" v-else class="timeline-carousel">
        <el-carousel-item v-for="item in images" :key="item.url" :initial-index="carouselIndex">
          <!-- <el-tooltip class="item" effect="dark" :content="item.title" placement="top"> -->
            <img :src="item.url" style="height: auto;width: 100%;"/>
          <!-- </el-tooltip> -->
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import interData from "@/mock/meeting_inter.json";
import visitData from "@/mock/meeting_visit.json";
export default {
  data() {
    return {
      timeline: undefined,
      dialogVisible: false,
      carouselIndex: 0,
      title: '',
      images: []
    };
  },
  mounted() {
    const type = this.$route.query.subType;
    const data = type === 'inter' ? interData : visitData;
    this.timeline = new TL.Timeline("timeline-embed", data, {
      slide_padding_lr: 1,
      initial_zoom:1
    });
    const initImageHandle = () => {
      setTimeout(_ => {
        const mediaElems = document.getElementsByClassName("tl-media-image");
        Array.prototype.forEach.call(mediaElems, image => {
          image.onclick = e => { //点击图片弹窗
            const index = e.target.getAttribute("title");
            if (index) {
              this.images = data.events[index].medias;
              this.title = this.images[0].title
              this.dialogVisible = true;
              // e.preventDefault();
              return false;
            }
          };
        });
      }, 2000);
    };
    this.timeline.on("loaded", data => {
      const linkElems = document.getElementsByTagName("a");

      Array.prototype.forEach.call(linkElems, a => {
        a.onclick = e => {  //点击查看更多弹窗
          const rel = e.target.getAttribute("rel");
          const href = e.target.href;
          if (rel === "noopener" && href) {
            let lidx = href.lastIndexOf("/");
            let idx = href.substring(lidx + 1);
            this.images = data.events[idx].medias;
            this.title = this.images[0].title
            this.dialogVisible = true;
            e.preventDefault();
            return false;
          }
        };
      });

      initImageHandle();
    });

    this.timeline.on("change", data => {
      initImageHandle();
    });
  },
  methods:{
    changeCarousel(index){
      this.title = this.images[index].title
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/components/meeting_timeline.vue